import React from "react";
import PropTypes from "prop-types";
import FormHelperText from "@material-ui/core/FormHelperText";

const HelperText = ({ text, error }) => (text ? <FormHelperText error={error}>{text}</FormHelperText> : null);

HelperText.propTypes = {
  /**
   * Texto de ayuda
   */
  text: PropTypes.string,
  /**
   * Indica si se aplican los estilos de error al texto
   */
  error: PropTypes.bool,
};

export default HelperText;
